import React, { Component } from 'react';
import { Form, FormGroup, SubmitButton } from '../../../../../../components/Forms/Forms';
import { Textarea } from '../../../../../../components/Forms/fields/index';

export class ClientNotesView extends Component {

  render() {
    const {
      addNoteActive,
      formState,
      onFormChange,
      submitForm,
      toggleAddNote,
      notes = [],
    } = this.props;
    return (
      <div className="client-notes-container">
        <div className="notes">
          {notes.concat().reverse().map((note, i)=> !i || addNoteActive ? (
            <div key={i} className="note">
              <span className="from">{note.from}</span>
              <span className="date">{(new Date(note.date)).toLocaleString()}</span>
              <div className="body">
                {note.text}
              </div>
            </div>
          ) : null)}
        </div>
        {!addNoteActive && (notes.length ? (
          <button className="toggle" onClick={()=>toggleAddNote(true)}>show more</button>
        ) : (
          <div>
            There are no notes for this client.
            <button className="toggle" onClick={()=>toggleAddNote(true)}>Click here</button>
            to add a note.
          </div>
        ))}
        {addNoteActive && (
          <Form state={formState} onChange={onFormChange} onSubmit={submitForm}>
            <FormGroup>
              <Textarea name="note" />
            </FormGroup>
            <button className="button" onClick={()=>toggleAddNote(false)}>hide</button>
            <SubmitButton className="button">Add Note</SubmitButton>
          </Form>
        )}
      </div>
    );
  }

}

export default ClientNotesView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientNotes/ClientNotes.view.js